module.exports = __webpack_public_path__ + "img/BTC-alt.76a6bba2.svg";